import React, { CSSProperties } from 'react';
import { IDataRequestActionDetailDto } from '@vivli/features/dashboard/infrastructure/interface';
import { ReadOnlyIdView, ReadOnlyTitleView, ButtonView, ReadOnlyTextView, ReadOnlyNumberView } from '@vivli/shared/views';
import { cardContainerStyle, upperSectionStyle, lowerSectionStyle } from './card-styles';
import { Color } from '@vivli/shared/theme';

interface DataRequestActionCardViewProps {
    dto: IDataRequestActionDetailDto;
    isVivliAdmin?: boolean;
    studiesLabel?: string;
}

const upperSectionStyleDR: CSSProperties = {
    ...upperSectionStyle,
    maxHeight: '65px',
};

const lowerSectionStyleDR: CSSProperties = {
    ...lowerSectionStyle,
    paddingTop: '5px',
    maxHeight: '65px',
};

export const DataRequestActionCardView = ({ dto, isVivliAdmin, studiesLabel }: DataRequestActionCardViewProps) => {
    const studiesContent = isVivliAdmin ? dto.numberOfStudies : dto.numberOfMyStudies;

    const handleActionDestination = () => {
        const genericDestination = `admindatarequests/active/${dto.uniqueId}/`;
        const nonUploadDestination = `${genericDestination}chat`;
        const uploadDestination = `${genericDestination}Studies`;
        const destinationToUse = dto.actionText === 'Upload Data Package' ? uploadDestination : nonUploadDestination;

        window.open(destinationToUse, '_blank');
    };

    return (
        <div style={cardContainerStyle}>
            <div style={upperSectionStyleDR}>
                <ReadOnlyIdView idContent={dto.vivliId} idHeader={'Vivli ID'}></ReadOnlyIdView>
                <ReadOnlyTitleView titleContent={dto.title} titleHeader={'Request Title'}></ReadOnlyTitleView>
                <div style={{ justifySelf: 'end' }}>
                    <ButtonView title={dto.actionText} theme={'white-on-lightblue'} onClick={handleActionDestination}>
                        {dto.actionText}
                    </ButtonView>
                </div>
            </div>
            <div style={lowerSectionStyleDR}>
                <div> </div>
                <ReadOnlyTextView
                    textContent={`${dto.leadInvestigatorFirstName} ${dto.leadInvestigatorLastName}`}
                    textHeader={'Lead Investigator'}
                ></ReadOnlyTextView>
                <ReadOnlyNumberView
                    numberContent={dto.daysLeft}
                    numberHeader={'Days in Current Step'}
                    useWarningColors={true}
                    warningOn={dto.daysWarning}
                ></ReadOnlyNumberView>
                <ReadOnlyNumberView
                    numberContent={studiesContent}
                    numberHeader={studiesLabel}
                    useWarningColors={false}
                ></ReadOnlyNumberView>
            </div>
        </div>
    );
};
